module.exports = __webpack_public_path__ + "static/media/xian.950a5999.png";